var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "16.279",
        viewBox: "0 0 16.27 16.279",
        width: "16.27",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "Path_520",
          d: "M2033.135,846.1a6.821,6.821,0,0,1-1.627,4.482l.1,2.889a.639.639,0,0,1-.3.564.59.59,0,0,1-.631.1l-2.955-1.162a7.069,7.069,0,0,1-2.358.2,4.975,4.975,0,0,1-4.515,1.029l-2.026,1a.644.644,0,0,1-.664-.033.626.626,0,0,1-.3-.6l.133-2.159a5.007,5.007,0,0,1-1.129-3.187,5.167,5.167,0,0,1,.233-1.544,5.07,5.07,0,0,1,.68-1.395,4.71,4.71,0,0,1,1.079-1.112,7.188,7.188,0,0,1,12.169-4.1,6.8,6.8,0,0,1,2.109,5.031Zm-12.651,6.773a.767.767,0,0,1,.5-.033,3.727,3.727,0,0,0,2.457-.1,7.153,7.153,0,0,1-3.054-2.208,6.824,6.824,0,0,1-1.494-3.436,3.659,3.659,0,0,0-.664,2.125,3.587,3.587,0,0,0,.962,2.49.578.578,0,0,1,.166.5l-.066,1.262,1.2-.6Zm9.662-2.49a.579.579,0,0,1,.167-.5,5.666,5.666,0,0,0-.25-7.853,5.65,5.65,0,0,0-4.1-1.676,5.783,5.783,0,0,0-5.777,5.279,3.361,3.361,0,0,0,.016,1,7.624,7.624,0,0,0,.382,1.444,6.42,6.42,0,0,0,.813,1.577,4.872,4.872,0,0,0,1.511,1.329,6.276,6.276,0,0,0,2.324.8,5.726,5.726,0,0,0,2.358-.166.493.493,0,0,1,.431,0l2.192.864-.067-2.092Zm-1.693-6.608a.638.638,0,0,1,.465.2.682.682,0,0,1,0,.963.641.641,0,0,1-.465.2h-4.682a.68.68,0,0,1-.5-.2.682.682,0,0,1,0-.963.676.676,0,0,1,.5-.2Zm0,3.553a.641.641,0,0,1,.465.2.682.682,0,0,1,0,.963.638.638,0,0,1-.465.2h-4.682a.682.682,0,0,1-.7-.7.639.639,0,0,1,.1-.332.676.676,0,0,1,.249-.249.708.708,0,0,1,.348-.083Z",
          "data-name": "Path 520",
          fill: "#ffa800",
          transform: "translate(-2016.865 -838.99)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }